import { faker } from "@faker-js/faker";

// Fixed seed for consistent data across page refreshes
const MOCK_SEED = 12345;

let isSeeded = false;

/**
 * Initialize faker with a fixed seed for deterministic data generation
 */
export function initializeSeed(): void {
  if (!isSeeded) {
    faker.seed(MOCK_SEED);
    isSeeded = true;
  }
}

/**
 * Reset the seed (useful for testing)
 */
export function resetSeed(): void {
  faker.seed(MOCK_SEED);
}

/**
 * Create a deterministic ID based on prefix and index
 */
export function createDeterministicId(prefix: string, index: number): string {
  return `${prefix}_${String(index).padStart(6, "0")}`;
}

/**
 * Create a seeded date with offset from base date
 */
export function createSeededDate(baseDate: Date, offsetDays: number): Date {
  const date = new Date(baseDate);

  date.setDate(date.getDate() + offsetDays);

  return date;
}

/**
 * Create a random date within a range
 */
export function createRandomDate(daysAgo: number, daysAhead: number = 0): Date {
  const now = new Date();
  const start = new Date(now);

  start.setDate(start.getDate() - daysAgo);
  const end = new Date(now);

  end.setDate(end.getDate() + daysAhead);

  return faker.date.between({ from: start, to: end });
}

/**
 * Get a seeded random element from an array
 */
export function getSeededElement<T>(array: T[]): T {
  return faker.helpers.arrayElement(array);
}

/**
 * Get multiple seeded random elements from an array
 */
export function getSeededElements<T>(array: T[], count: number): T[] {
  return faker.helpers.arrayElements(array, count);
}
